import { createI18n } from 'vue-i18n';
import { ref } from 'vue';
const firstLoad = ref(true);
const loadedLocales = new Set();

const loadLocaleMessages = async (locale) => {
  let commonLocale = null;
  let amenitiesLocale = null;
  let commonJson = {};
  let amenitiesJson = {};
  try {
    commonLocale = await fetch(
      /* @vite-ignore */ `/locales/general/${locale}.json`,
    );
    commonJson = await commonLocale.json();
  } catch (error) {
    console.warn('missing common locale', locale);
    commonLocale = await fetch(
      /* @vite-ignore */ `/locales/general/${i18n.global.fallbackLocale.value}.json`,
    );
    commonJson = await commonLocale.json();
  }

  try {
    amenitiesLocale = await fetch(
      /* @vite-ignore */ `/locales/amenities/${locale}.json`,
    );
    amenitiesJson = await amenitiesLocale.json();
  } catch (error) {
    console.warn('missing amenities locale', locale);
  }

  return {
    amenities: amenitiesJson,
    general: commonJson,
  };
};

const i18n = createI18n({
  locale: 'pt',
  fallbackLocale: 'en',
  legacy: false,
  messages: {},
  datetimeFormats: {},
  warnHtmlMessage: false,
});

const setLocale = async (locale, labels = null) => {
  if (loadedLocales.has(locale)) {
    if (labels) {
      const existing = i18n.global.getLocaleMessage(locale) || {};
      i18n.global.setLocaleMessage(locale, { ...existing, ...labels });
    }
    i18n.global.locale.value = locale;
    return;
  }

  if (firstLoad.value && i18n.global.fallbackLocale.value !== locale) {
    const fallbackMessages = await loadLocaleMessages(
      i18n.global.fallbackLocale.value,
    );
    i18n.global.setLocaleMessage(
      i18n.global.fallbackLocale.value,
      fallbackMessages,
    );
    loadedLocales.add(i18n.global.fallbackLocale.value);
  }
  firstLoad.value = false;

  try {
    const messages = await loadLocaleMessages(locale);
    const merged = labels ? { ...messages, ...labels } : messages;
    i18n.global.setLocaleMessage(locale, merged);
    i18n.global.locale.value = locale;
    loadedLocales.add(locale);
  } catch (error) {
    console.error('missing locale', locale);
  }
};

export { i18n, loadLocaleMessages, setLocale };
